import strings from 'lib/strings';
import firebase from 'lib/firebase';
import { setLanguage } from 'store/language/actions';

const getDirection = language =>
  language === 'he' ? 'rtl' : 'ltr'

export default store => next => action => {
  // eslint-disable-next-line
  if (action.type == setLanguage) {
    const language = action.payload;
    strings.setLanguage(language);
    firebase.auth().languageCode = language;

    // Set document direction
    document.getElementsByTagName("body")[0].dir = getDirection(language);

    // Set page title
    document.title = strings["app_title"];
  }

  return next(action);
}



// WEBPACK FOOTER //
// ./src/store/middlewares/setLanguage.js